<script setup>
import { provide, computed } from 'vue';

const props = defineProps({
  index: { type: Number, default: 0 },
  border: { type: Boolean, default: true },
});

const emit = defineEmits(['change']);
const activeIndex = computed(() => props.index);
provide('activeIndex', activeIndex);
provide('updateActiveIndex', index => emit('change', index));
</script>

<template>
  <div class="flex min-w-0" :class="{ 'border-b border-n-weak': border }">
    <ul
      role="tablist"
      class="m-0 flex min-w-0 max-w-full list-none overflow-x-auto px-4 py-0 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
    >
      <slot />
    </ul>
  </div>
</template>
